import {} from "./Net.js";
import { clonePortEntry } from "./clonePortEntry.js";
export function clonePortRecord(record) {
    return Object.fromEntries(Object.entries(record).map(([name, portEntry]) => [
        name,
        clonePortEntry(portEntry),
    ]));
}
//# sourceMappingURL=clonePortRecord.js.map